import { css } from "@emotion/react";

import * as dimensions from "@styles/emotion-styles/dimensions";

const skeletonHeight = "height: 2.75rem";

export const header = css`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 1rem 0;
`;

export const title = css`
  align-self: center;
`;

export const actions = css`
  display: flex;
  justify-content: flex-end;
`;

export const titleSkeleton = css`
  ${skeletonHeight};
`;

export const sortDropdownSkeleton = css`
  ${skeletonHeight};
`;
export const gridListSelector = css`
  margin-top: 0;
  margin-left: 1rem;
  ${skeletonHeight};
`;

export const margin = css`
  margin: 2rem 0 0;
  @media screen and (max-width: ${dimensions.tablet}) {
    margin: 1.5rem 0 0;
  }
`;
